import * as types from 'actions/loader/types';

const initialState = {
  isLoading: false,
  type: 'regular',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW:
      return { ...state, isLoading: true, type: action.payload?.type || 'regular' };
    case types.HIDE:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};
